<div class="gd-app-shell">
  <gd-header *ngIf="showAuthenticatedHeader"></gd-header>
  <router-outlet></router-outlet>
</div>
<gd-spinner></gd-spinner>
